@if (open()) {
  <div class="aa-overlay" (click)="onClose()"></div>

  <aside class="aa" role="dialog" aria-label="Add asset">
    <!-- header -->
    <header class="aa-head">
      <button class="aa-close" type="button" (click)="onClose()" aria-label="Close" [disabled]="saving()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <div class="aa-title">Add Asset</div>
      <div class="aa-subtitle">Attach a document to this project, as a link or an upload.</div>
    </header>

    <!-- body -->
    <div class="aa-body">
      <div class="aa-field">
        <span class="aa-label" id="aa-type-label">Type</span>
        <div class="aa-segments" role="radiogroup" aria-labelledby="aa-type-label">
          @for (option of assetTypeOptions; track option.value) {
            <button
              class="aa-segment"
              type="button"
              role="radio"
              [attr.aria-checked]="assetType() === option.value"
              [class.on]="assetType() === option.value"
              [disabled]="saving()"
              (click)="assetType.set(option.value)"
            >
              {{ option.label }}
            </button>
          }
        </div>
      </div>

      <div class="aa-field">
        <span class="aa-label" id="aa-source-label">Add as</span>
        <div class="aa-segments" role="radiogroup" aria-labelledby="aa-source-label">
          <button
            class="aa-segment"
            type="button"
            role="radio"
            [attr.aria-checked]="source() === 'link'"
            [class.on]="source() === 'link'"
            [disabled]="saving()"
            (click)="setSource('link')"
          >
            Link
          </button>
          <button
            class="aa-segment"
            type="button"
            role="radio"
            [attr.aria-checked]="source() === 'upload'"
            [class.on]="source() === 'upload'"
            [disabled]="saving()"
            (click)="setSource('upload')"
          >
            Upload file
          </button>
        </div>
      </div>

      @if (source() === 'link') {
        <label class="aa-field">
          <span class="aa-label">Link</span>
          <input
            class="aa-input"
            type="url"
            placeholder="https://docs.google.com/…"
            [value]="linkUrl()"
            [disabled]="saving()"
            (input)="linkUrl.set($any($event.target).value)"
            (keydown.enter)="add()"
          />
        </label>
      } @else {
        <label class="aa-drop">
          <input type="file" [accept]="acceptedFileTypes" (change)="onFileSelected($event)" [disabled]="saving()" hidden />
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" />
          </svg>
          @if (chosenFile(); as selectedFile) {
            <div class="aa-drop-main">{{ selectedFile.name }}</div>
            <div class="aa-drop-sub">Click to choose a different file</div>
          } @else {
            <div class="aa-drop-main">Choose a file</div>
            <div class="aa-drop-sub">PDF, Word, Excel, PowerPoint, CSV or text</div>
          }
        </label>
        @if (uploadProgress() !== null) {
          <div class="aa-bar" role="progressbar" [attr.aria-valuenow]="uploadProgress()" aria-valuemin="0" aria-valuemax="100">
            <div class="aa-bar-fill" [style.width.%]="uploadProgress()"></div>
          </div>
        }
      }

      <label class="aa-field">
        <span class="aa-label">Title <span class="aa-optional">(optional)</span></span>
        <input
          class="aa-input"
          type="text"
          maxlength="200"
          [placeholder]="source() === 'upload' ? 'Defaults to the file name' : 'e.g. Homepage copy v3'"
          [value]="title()"
          [disabled]="saving()"
          (input)="title.set($any($event.target).value)"
        />
      </label>

      @if (errorMessage(); as message) {
        <p class="aa-error" role="alert">{{ message }}</p>
      }
    </div>

    <!-- footer -->
    <footer class="aa-foot">
      <button class="aa-btn ghost" type="button" (click)="onClose()" [disabled]="saving()">Cancel</button>
      <button class="aa-btn primary" type="button" (click)="add()" [disabled]="!canAdd()">
        @if (saving()) {
          <span class="aa-spinner" aria-hidden="true"></span> Adding…
        } @else {
          Add Asset
        }
      </button>
    </footer>
  </aside>
}
